<template>
    <div class="file-list">
        <div :key="index" v-for="(file, index) in files" class="file-list__item">
            <file-item @remove="remove" :file="file"/>
        </div>
    </div>
</template>

<script>
import FileItem from '@/modules/ProjectModule/modules/UnitModule/components/File/FileItem';

export default {
    name:       'FileList',
    components: {FileItem},
    computed:   {
        files() {
            return this.$store.getters['projects/project/units/unit/files'];
        }
    },
    methods:    {
        remove(fileId) {
            this.$store.dispatch('projects/project/units/unit/removeFiles', [fileId])
                .catch((message) => this.$dmv.notifyError(message));
        }
    }
}
</script>
